module.exports = __webpack_public_path__ + "img/lable_books_jb.a9f40f0b.svg";